import { render, staticRenderFns } from "./correct_class.vue?vue&type=template&id=5586c588&scoped=true&"
import script from "./correct_class.vue?vue&type=script&lang=js&"
export * from "./correct_class.vue?vue&type=script&lang=js&"
import style0 from "./correct_class.vue?vue&type=style&index=0&id=5586c588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586c588",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
